import { useCallback, useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import SortBy from './SortBy';

const ActionBar = ({ onChangeSortBy, isLoading }) => {
  const [sortBy, setSortBy] = useState();

  const handleChangeSortBy = useCallback(
    (sortByItem) => {
      setSortBy(sortByItem);

      onChangeSortBy(sortByItem.value);
    },
    [setSortBy, onChangeSortBy],
  );

  return (
    <Box alignItems="center" justifyContent="flex-end" mt={8} mb={5}>
      <SortBy
        value={sortBy}
        onChange={handleChangeSortBy}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ActionBar;
